export default __webpack_public_path__ + "static/media/SG.8d448258.ico";